<template>
    <div class="page">
        <div class="public-head">
            <Head></Head>
            <div class="baikuang" @click="jump('/acount/today-logs')">
                <p>{{$t('profile.TodayLogs')}}</p>
                <span>{{info ? info.dayTotalLogs : 0}}</span>
            </div>
            <div class="baikuang baikuang-1" @click="jump('/acount/total')">
                <p>{{$t('profile.Total')}}</p>
                <span>{{info ? info.total : 0}}</span>
            </div>
            <div class="baikuang baikuang-1" @click="jump('/acount/this-month')">
                <p>{{$t('profile.ThisMonth')}}</p>
                <span>{{info ? info.monthTotal : 0}}</span>
            </div>
        </div>
        <div class="box">
            <div>
                <div>
                  <p v-html="$t('profile.Parcels')"></p>
                  <p v-html="$t('profile.withLabel')"></p>
                </div>
                <p>{{info ? info.withLabelTotal : 0}}</p>
            </div>
            <div>
                <div>
                  <p v-html="$t('profile.Parcels')"></p>
                  <p v-html="$t('profile.withoutLabel')"></p>
                </div>
                <p>{{info ? info.withoutLabelTotal : 0}}</p>
            </div>
        </div>
        <div class="public-body">
            <div class="Profile-div">
                <div class="Profile-content">
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.LocationID')}}
                        </p>
                        <span>
                            {{info ? info.siteSerialNumber : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.LocationName')}}
                        </p>
                        <span>
                            {{info ? info.siteNameEn : ''}}
                        </span>
                        <br>
                        <span>
                            {{info ? info.siteName : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.Address')}}
                        </p>
                        <span>
                           {{info && info.streetAddressEn ? info.streetAddressEn + '&nbsp;' : ''}}
                           {{info ? info.houseNumberEn : ''}}
                        </span>
                        <br>
                        <span>
                            {{info && info.streetAddress ? info.streetAddress + '&nbsp;' : ''}}
                            {{info ? info.houseNumber : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.ShopContact')}}
                        </p>
                        <span>
                            {{info ? info.contact : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.Username')}}
                        </p>
                        <span>
                            {{info ? info.username : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav">
                        <p>
                            {{$t('profile.RegisteredPhoneNumber')}}
                        </p>
                        <span>
                            {{info ? info.registedMobile : ''}}
                        </span>
                    </div>
                    <div class="Profile-nav-last">
                        <p>{{$t('profile.BusinessHours')}}</p>
                        <p v-for="day in BusinessHours">
                            <span>{{$t('editProfile.' + day.weekDay)}}: </span>
                            <span v-for="time in day.siteServiceTimes">{{time.openTime + '-' + time.closeTime + '&nbsp; '}}</span>
                        </p>
                        <p v-for="item in special">
                            <span>{{timestampToString(item)}}</span>
                        </p>
                    </div>
                </div>
                <div class="Profile-Choice">
                    <!-- <p class="Profile-edit" @click="edit()">{{$t('profile.Edit')}}</p> -->
                    <p class="Profile-logout" @click="logout">{{$t('profile.Logout')}}</p>
                </div>
            </div>

            <div class="Profile-today">
            </div>
            <div class="Profile-home" @click="home()">
                {{$t('common.Home')}}
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from './Bottom.vue'
import Head from './Acount/Head.vue'

export default {
  components: {bottom, Head},
  data () {
    return {
      p: '',
      span: '',
      info: null,
      siteInfo: null,
      timeList: [],
      locationName: localStorage.getItem('locationName'),
      BusinessHours: [],
      special: [],
      timer: null
    }
  },
  methods: {
    jump (path) {
      this.$router.push(path)
    },
    logout () {
      localStorage.removeItem('token')
      this.$store.commit('cleanToken')
      this.$router.push({path: '/'})
    },
    edit () {
      this.$router.push({name: 'Editprofile', query: {'siteId': this.info.siteId}})
    },
    home () {
      this.$router.push({name: 'Index'})
    },
    siteDetail (siteId) {
      // 自提点信息获取
      const vue = this
      this.axios({
        method: 'get',
        url: this.api.siteDetail + siteId
      }).then(function (response) {
        vue.siteInfo = response.data
        vue.timeList = response.data.serviceTimeList
        vue.initTime()
      }).catch(function (error) {
        console.log(error.data)
      })
    },
    timestampToString (c_time = 0) {
      c_time = Number(c_time)
      let monthArr, weekArr
      monthArr = this.$t('common.monthArr')
      weekArr = this.$t('common.weekArr')
      let time = new Date(c_time)
      // 获取月份
      let m = monthArr[time.getMonth()] + this.$t('common.space')
      // 获取当月的第几日
      let day = time.getDate() + this.$t('common.dayFormat')
      // 获取一周中的第几日
      let week = weekArr[time.getDay()]
      return week + ', ' + m + day
    },
    initTime () {
      for (let i = 0; i < this.timeList.length; i++) {
        let weekName = this.timeList[i].weekDay
        if (weekName === 'Special') {
          let tmpData = this.timeList[i].siteServiceTimes
          for (let i = 0; i < tmpData.length; i++) {
            this.special.push(tmpData[i].openTime)
          }
        } else {
          this.BusinessHours.push(this.timeList[i])
        }
      }
      console.log(this.BusinessHours)
    },
    async getAccountInfo () {
      const vue = this
      try {
        const response = await vue.axios({
          method: 'get',
          url: this.api.accountInfo
        })
        vue.info = response.data
        return response
      } catch (error) {
        console.log(error.data)
      }
    }
  },
  async created () {
    // 初始化注入&校验时请求页面数据
    // 个人信息获取
    const vue = this
    const res = await vue.getAccountInfo()
    vue.siteDetail(res.data.siteId)
    vue.timer = setInterval(() => {
      vue.getAccountInfo()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style src="../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .baikuang {
        border-radius: 0.1rem;
    }

    .Profile-home {
        bottom: 0.25rem;
    }

    .public-body {
        margin-top: 0.25rem;
    }

    .bottom {
        margin-top: 30% !important;
    }
    .box{
      width: 100%;
      padding: 3.33% 3.33% 0;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    .box>div{
      width: 49%;
      height: 0.95rem;
      background-color: white;
      -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
      border-radius: 20px;
      display: flex;
      align-items: center;
      font-size: 0.15rem;
      font-family: Poppins-Bold;
      line-height: 0.18rem;
      color: var(--primary-text-color);
      padding-left: 3.29% !important;
    }
    .box>div>p{
      flex: 1;
      text-align: center;
      font-size: 0.25rem;
      font-family: Poppins-Bold;
      color: var(--primary-text-color);
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue